import React, { useState } from "react";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import ReviewNewOrderList from "../../Grid/ReviewNewOrderList";
import ReviewChangeOrderList from "../../Grid/ReviewChangeOrderList";
import "./ReviewOrder.css";
const renderCustomItem = () => {
  return <div>Custom Item</div>;
};
const ReviewOrder = () => {
  return (
    <React.Fragment>
      <TabPanel className="review-tabs" style={{ height: "calc(100vh - 85px)" }}>
        <Item title="New Orders" icon="edit" render={renderCustomItem}>
          <ReviewNewOrderList />
        </Item>
        <Item title="Change Orders" icon="return">
          <ReviewChangeOrderList />
        </Item>
      </TabPanel>
    </React.Fragment>
  );
};

export default ReviewOrder;

